import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {InstancePO} from "@/model/workflow";
import {ExecutePO} from "@/model/workflow";

export enum InstanceEnum {
    GetInstancePage = "/instance/getInstancePage",
    GetInstance = "/instance/getInstance",
    GetCurrentExecute = "/instance/getCurrentExecute",
    CreateInstance = "/instance/createInstance",
    SearchInstance = "/instance/searchInstance",
    AgreeExecute = "/instance/agreeExecute",
    RejectExecute = "/instance/rejectExecute",
    RevokeExecute = "/execute/revokeExecute",
    GetPendingReview = "/instance/pendingReview"
}

export interface InstancePageBO {
    keyword?: string;
}

export interface SearchInstanceVO extends InstancePO {
    names: string;
}

export interface ExecuteBO {
    instanceId?: number;
    executeId?: string;
    businessId?: number
}

export interface RejectExecuteBO {
    instanceId: number;
    remark: string
}

export interface ReviewStatusVO {
    auditStatus: number;
    nodeNames: string;
    processorIds: string;
}

export interface CurrentExecuteVO {
    revoked: boolean;
    executes: ExecutePO[]
}

export const useQueryInstancePage = () => useMutation<BaseVO<PaginationVO<InstancePO>>, null, InstancePageBO>({
    mutationFn: (data: InstancePageBO) => http.post<BaseVO<PaginationVO<InstancePO>>>({
        url: InstanceEnum.GetInstancePage,
        data: data,
    }),
})

export const useQueryPendingReview = () => useMutation<BaseVO<PaginationVO<InstancePO>>, null, InstancePageBO>({
    mutationFn: (data: InstancePageBO) => http.post<BaseVO<PaginationVO<InstancePO>>>({
        url: InstanceEnum.GetPendingReview,
        data: data,
    }),
})

export const useAgreeExecute = () => useMutation({
    mutationFn: ({executeId, instanceId}: ExecuteBO) => http.get<BaseVO<null>>({url: InstanceEnum.AgreeExecute, params: {executeId, instanceId: instanceId?.toString()}}),
})

export const useRevokeExecute = () => useMutation({
    mutationFn: (instanceId: number) => http.get<BaseVO<null>>({url: InstanceEnum.RevokeExecute, params: {id: instanceId}}),
})


export const useRejectExecute = () => useMutation({
    mutationFn: (data: RejectExecuteBO) => http.post({url: InstanceEnum.RejectExecute, data}),
})

export const useQueryCurrentExecute = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<CurrentExecuteVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<CurrentExecuteVO>>({
        url: InstanceEnum.GetCurrentExecute,
        params: params
    }),
    enabled
})


